import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toDate } from "date-fns";
import { ADMIN_API_ENDPOINTS } from "service/apiUrl";
import { API } from "service/Interceptor";

const initialState = {
  projects: [],
  filters: {
    fromDate: "",
    toDate: "",
    status: "",
    flaggedStatus: "",
  },
  totalCount: null,
  isProjectsLoading: false,
  hasError: false,
  isExporting: false,
};

// export const getAllProjects = createAsyncThunk(
//   "get-all-projects",
//   async ({ pageSelected, search }) => {
//     try {
//       const res = await API.get(
//         `${ADMIN_API_ENDPOINTS.PROJECTS}?search=${
//           search || ""
//         }&export=false&pageNo=${pageSelected}&perPage=10`
//       );
//       return {
//         data: res?.data?.data?.results,
//         totalRecord: res?.data?.data?.totalRecord,
//       };
//     } catch (error) {
//       console.log(error);
//     }
//   }
// );

export const getAllProjects = createAsyncThunk(
  "admin/get-all-projects",
  async ({ pageSelected, search, filters }) => {
    try {
      const { fromDate, toDate, status, flaggedStatus } = filters || {};

      const queryParams = new URLSearchParams({
        search: search || "",
        export: "false",
        pageNo: pageSelected,
        perPage: 10,
      });

      if (fromDate) queryParams.append("fromDate", fromDate);
      if (toDate) queryParams.append("toDate", toDate);
      if (status) queryParams.append("isActive", status);
      if (flaggedStatus) queryParams.append("flaggedStatus", flaggedStatus);

      const res = await API.get(
        `${ADMIN_API_ENDPOINTS.PROJECTS}?${queryParams.toString()}`
      );

      const results = res?.data?.data?.results;
      return {
        data: Array.isArray(results) ? results : [],
        totalRecord: res?.data?.data?.totalRecord || 0,
      };
    } catch (error) {
      console.log(error);
      return { data: [], totalRecord: 0 };
    }
  }
);


export const handleProjectStatus = createAsyncThunk(
  "update-project-status",
  async (payload, { rejectWithValue }) => {
    try {
      await API.post(ADMIN_API_ENDPOINTS.PROJECT_STATUS, {
        status: payload?.isActive,
        jobId: payload?.jobAliasId,
        message: payload?.message,
      });

      return {
        jobAliasId: payload?.jobAliasId,
        reportMessage: payload.message,
      };
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Could not update project status"
      );
    }
  }
);

export const handleProjectFlaggedStatus = createAsyncThunk(
  "update-project-flagged-status",
  async (payload) => {
    try {
      await API.put(ADMIN_API_ENDPOINTS.PROJECT_FLAG_STATUS, payload);
      return payload;
    } catch (error) {
      console.log(error);
    }
  }
);

export const exportProjects = createAsyncThunk(
  "export-projects",
  async (payload) => {
    try {
      const res = await API.get(`${ADMIN_API_ENDPOINTS.PROJECTS}?export=true`, {
        responseType: "blob",
      });
      return res;
    } catch (error) {
      console.log("error", error);
    }
  }
);

export const projectMonitoringSlice = createSlice({
  name: "projects",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder
      // ------------------GET ALL USERS------------------
      .addCase(getAllProjects.pending, (state, action) => {
        state.isProjectsLoading = true;
        state.hasError = false;
      })
      .addCase(getAllProjects.rejected, (state, action) => {
        state.isProjectsLoading = false;
        state.hasError = true;
      })
      .addCase(getAllProjects.fulfilled, (state, action) => {
        state.isProjectsLoading = false;
        state.hasError = false;
        state.projects = Array.isArray(action.payload?.data)
          ? action.payload.data
          : [];
        state.totalCount = action.payload?.totalRecord || 0;
      })
      // --------------------Toggle Status------------------
      .addCase(handleProjectStatus.fulfilled, (state, action) => {
        const index = (state.projects || []).findIndex(
          (row) => row.jobAliasId === action.payload?.jobAliasId
        );
        if (index < 0) return;
        state.projects[index].isActive = !state.projects[index].isActive;
        state.projects[index].flaggedReason = action.payload?.reportMessage;
      })
      // --------------------Toggle Flag Status------------------
      .addCase(handleProjectFlaggedStatus.fulfilled, (state, action) => {
        const index = (state.projects || []).findIndex(
          (row) => row.jobAliasId === action.payload?.jobId
        );
        if (index < 0) return;
        state.projects[index].isReported = !state.projects[index].isReported;
        state.projects[index].flaggedStatus = action.payload?.flaggedStatus;
      })
      // --------------------Exporting Projects------------------
      .addCase(exportProjects.pending, (state, action) => {
        state.isExporting = true;
      })
      .addCase(exportProjects.fulfilled, (state, action) => {
        state.isExporting = false;
      })
      .addCase(exportProjects.rejected, (state, action) => {
        state.isExporting = false;
      });
  },
});

export const { setFilters } = projectMonitoringSlice.actions;
export default projectMonitoringSlice.reducer;
